import React, {Component} from "react";
import TopNav from "../common/nav/TopNav";
import Footer from "../common/Footer";
import PriceList from "./common/PriceList";
import PageBlock from "../common/PageBlock";

class Pricing extends Component {
    render() {
        return (
            <div>
                <TopNav tab="pricing" title="Price plans"/>

                <PageBlock>
                    <div className="container text-center">
                        <div className="row m-b-md m-t-md-c-xs m-t-md-c-sm">
                            <div className="col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3">
                                <h6 className="text-muted text-uppercase">Business Talk</h6>
                                <h3 className="m-t-0">Plans to fit your project. <br className="hidden-xs"/>Starts from free.
                                </h3>
                            </div>
                        </div>
                    </div>

                    <PriceList/>
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default Pricing;



// WEBPACK FOOTER //
// ./src/modules/views/Pricing.js